export default (state, { payload }) => {
    const { ticketTypes } = state;
    if (!Array.isArray(ticketTypes)) {
        return state;
    }

    const index = ticketTypes.findIndex(ticketType => ticketType.hash === payload.ticketTypeHash);
    if (index !== -1) {
        const ticketType = ticketTypes[index];
        ticketType.purchased_tickets_count -= payload.usedSeatsCount || 1;
        ticketTypes.splice(index, 1, {...ticketType});
        state.ticketTypes = [...ticketTypes];
    }

    return { ...state };
};
